<template>
  <div>
    <div class="col-lg-12">
      <modal :show.sync="modals.requestquotation" class="modal-eprf" centered>
        <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
          header="Fill in the details." header-bg-variant="primary" header-text-variant="white">
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">Fill in the details.</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i style="
                            transform: translate(-50%, -50%);
                            color: white;
                            font-weight: 900;
                            font-size: 12px;
                            " class="tim-icons icon-simple-remove" @click="modals.requestquotation = false"></i>
                </base-button>
              </div>
            </div>
          </template>
          <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">
            <div style="padding: 5px 20px 0px 20px;">
              <div class="row">
                <div class="col-lg-12">
                  <p style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 17px;">
                    Order Requested
                  </p>
                </div>
              </div>
              <div v-for="(product, index) in products" :key="index" class="product-row">
                <div v-if="cartids.includes(product.cartid)" class="col-lg-12">
                  <div class="row" style="align-items: center; align-content: center; align-self: center;">
                    <div class="col-lg-4" style="padding: 10px;">
                      <img :src="product.image.fileurl" class="product-image" style="max-height: 100px;" />
                    </div>
                    <div class="col-lg-8">
                      <div class="product-name" style="text-align: left;">{{ product.name }}</div>
                      <div class="product-name" style="text-align: right; margin-right: 10px;">Quantity: {{
                        product.quantity }} Kg
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <p style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 17px;">
                    Choose Service Location <span style="color: #EC1B23;">*</span>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8">
                  <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.servicelocation"
                    style="width: 100%; border-bottom: 1px solid #aaa" filterable>
                    <el-option v-for="option in selects.servicelocations" class="select-info" :value="option.value"
                      :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
              </div>
              <br />

              <div class="row">
                <div class="col-lg-12">
                  <p style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 17px;">
                    Choose Delivery option <span style="color: #EC1B23;">*</span>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8">
                  <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.deliveryoption"
                    style="width: 100%; border-bottom: 1px solid #aaa" filterable>
                    <el-option v-for="option in selects.deliveryoptions" class="select-info" :value="option.value"
                      :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
              </div>
              <br />

              <div v-if="selects.deliveryoption == '2'" class="row">
                <div class="col-lg-12">
                  <p style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 17px;">
                    Delivery Address <span style="color: #EC1B23;">*</span>
                  </p>
                </div>
              </div>
              <div v-if="selects.deliveryoption == '2'">
                <div class="row">
                  <div class="col-lg-3 text-left">
                    <p style="color: #A5A5A5; font-size: 17px;">Street Address 1<span style="color: #EC1B23;">*</span></p>
                  </div>
                  <div class="col-lg-9">
                    <input type="text" v-model="addressline1" :class="{ 'custom-input': true }" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 text-left">
                    <p style="color: #A5A5A5; font-size: 17px;">Street Address 2</p>

                  </div>
                  <div class="col-lg-9">
                    <input type="text" v-model="addressline2" :class="{ 'custom-input': true }" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 text-left">
                    <p style="color: #A5A5A5; font-size: 17px;">City<span style="color: #EC1B23;">*</span></p>

                  </div>
                  <div class="col-lg-6 text-left">
                    <p style="color: #A5A5A5; font-size: 17px;">Postcode<span style="color: #EC1B23;">*</span></p>

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <input type="text" v-model="city" :class="{ 'custom-input': true }" />
                  </div>
                  <div class="col-lg-6">
                    <input type="number" v-model="postcode" :class="{ 'custom-input': true }" min="00000" max="99999"
                      required @input="validatePostcode" />

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6 text-left">
                    <p style="color: #A5A5A5; font-size: 17px;">State<span style="color: #EC1B23;">*</span></p>

                  </div>
                  <div class="col-lg-6 text-left">
                    <p style="color: #A5A5A5; font-size: 17px;">Country</p>

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.state"
                      style="width: 100%; border-bottom: 1px solid #aaa" filterable>
                      <el-option v-for="option in selects.states" class="select-info" :value="option"
                        :label="option.label" :key="option.value"></el-option>
                    </el-select>
                  </div>
                  <div class="col-lg-6">
                    <p style="color: #A5A5A5; font-size: 17px;">Malaysia</p>
                    <!-- <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.country"
                    style="width: 100%; border-bottom: 1px solid #aaa" :disabled="true" filterable>
                    <el-option v-for="option in selects.countries" class="select-info" :value="option"
                      :label="option.label" :key="option.value"></el-option>
                  </el-select> -->
                  </div>
                </div>

              </div>


              <br />

              <div class="row">
                <div class="col-lg-12">
                  <p style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 17px;">
                    Remarks
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <textarea style="height: 100px; border: 1px solid #aaa; background-color: white;" type="textarea"
                    placeholder="Remarks..." v-model="custremark" :class="{ textarea: true }"></textarea>
                </div>
              </div>

              <div class="row">
                <div class="col-lg text-right">
                  <base-button v-if="selects.deliveryoption == '2'" type="primary" v-on:click="requestQuotation()"
                    :disabled="candeliver">Submit</base-button>
                  <base-button v-else-if="selects.deliveryoption == '1'" type="primary" v-on:click="requestQuotation()"
                    :disabled="cansubmit">Submit</base-button>
                  <base-button v-else type="primary" disabled>Submit</base-button>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </modal>

      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
      <StatusModal :show.sync="modals.removeModal" :message="modal.deleteItemSuccess" :title="modal.deleteTitle" />
      <StatusModal :show.sync="modals.removeFailedModal" :message="modal.deleteItemFailed" :title="modal.deleteTitle" />

      <div class="row">
        <div class="col-lg-12">
          <base-button style="font-size: 18px" @click="goBack()" class="btn-link btn-back">
            &lt; Back
          </base-button>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-8">
          <div class="cart-table mt-3" v-if="products.length > 0">
            <div class="select-all-header">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-1 text-center">
                    <input type="checkbox" @change="selectAll" :checked="allproducts" />
                  </div>
                  <div class="col-lg-3 text-center" style="justify-content: space-between;">
                    <div class="row">
                      <div class="col-lg">
                        <span style="color:#358CCB" class="select-all-text">Select All ({{ products.length }})</span>
                      </div>
                      <div class="col-lg-2">
                        <i class="tim-icons icon-trash-simple" style="
                    color: #EC1B23;
                    font-weight: 900;
                    font-size: 17px;
                  " @click="deleteProduct(cartids)"></i>
                      </div>
                    </div>

                  </div>
                  <div class="col-lg-4 text-center">
                    <span class="header-text">Product</span>
                  </div>
                  <div class="col-lg-3 text-center">
                    <span class="header-text">Quantity</span>
                  </div>
                  <div class="col-lg-1 text-left">
                    <span class="header-text" style="margin-left: -10px;">Action</span>
                  </div>

                </div>
              </div>
            </div>

            <div class="product-list">
              <div v-for="(product, index) in products" :key="index" class="product-row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-1 text-center" style="align-items: center; align-content: center;">
                      <input type="checkbox" :value="product.cartid" v-model="cartids"
                        @change="updateCartIds(product.cartid, $event)" />
                    </div>
                    <div class="col-lg-7 text-center">
                      <div class="row" style="align-items: center; align-content: center; align-self: center;">
                        <div class="col-lg-5">
                          <img :src="product.image.fileurl" class="product-image" />
                        </div>
                        <div class="col-lg-7">
                          <div class="product-name">{{ product.name }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-center" style=" align-content: center; align-self: center;">

                      <!-- <div class="button-group"> -->
                      <div class="row justify-content-center align-items-center">
                        <!-- <div class="d-flex mb-2 quantity-control"> -->
                        <button class="btn-decrease" @click="decreaseQuantity(product)">-</button>
                        <input type="number" v-model.number="product.quantity"
                          class="quantity-display quantity-input no-stepper" @input="onQuantityChange(product)" />
                        <button class="btn-increase" @click="increaseQuantity(product)">+</button>
                        <p style="color: #A5A5A5; margin-left: 10px">Kg</p>
                      </div>
                      <!-- </div> -->
                      <!-- </div> -->
                    </div>

                    <!-- <div v-if="cartids.length >= 1" @click="deleteProduct(cartids)" class="col-lg-1 text-center"
                      style="background-color: #EC1B23; border-radius:0px 5px 5px 0px; cursor: pointer; align-items: center; color: white; align-content: center;">
                      Delete
                    </div> -->
                    <div @click="deleteItem(product.cartid)" class="col-lg-1 text-center"
                      style="background-color: #EC1B23; border-radius:0px 5px 5px 0px; cursor: pointer; align-items: center; color: white; align-content: center;">
                      Delete
                    </div>
                  </div>
                </div>
                <!-- <input class="c-box" type="checkbox" v-model="product.selected" />
                <img :src="product.image" class="product-image" />
                <div class="product-details">
                  <div class="product-name">{{ product.name }}</div>
                  <div class="quantity-control">
                    <button class="btn-decrease" @click="decreaseQuantity(product)">-</button>
                    <div class="quantity-display">{{ product.quantity }}</div>
                    <button class="btn-increase" @click="increaseQuantity(product)">+</button>
                  </div>
                </div>
                <div class="btn btn-danger delete-button" @click="deleteProduct(index)">
                  Delete
                </div> -->
              </div>
            </div>
          </div>
          <div v-else>
            <p>Your cart is empty</p>
          </div>

          <div class="cart-footer" v-if="products.length > 0">
            <p v-text="`Total (${this.cartids.length} ${this.cartids.length <= 1 ? 'item' : 'items'} selected)`"></p>
            <button class="btn btn-primary" @click="modals.requestquotation = true" :disabled="canrequest">Request
              Quotation</button>
          </div>
        </div>
        <div class="col-lg"></div>
      </div>

    </div>
  </div>
</template>


<script>
import BaseButton from '../../../components/BaseButton.vue';
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import { BCard } from "bootstrap-vue";
import StatusModal from 'src/components/StatusModal.vue';
import { modal } from "src/components/variable.js";
import { getStorage } from "../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

export default {
  name: "Cart",

  components: {
    BaseButton,
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
    BCard,
    StatusModal,
  },
  data() {
    return {
      addressline1: '',
      addressline2: '',
      city: '', //auto based on postcode
      postcode: '',
      state: '', //dropdown @ auto based on postcode
      country: '',

      cartids: [],
      preview: "",
      custremark: '',
      servicelocation: 1,
      products: [],
      allSelected: false,

      modal: modal,
      modals: {
        successModal: false,
        removeModal: false,
        removeFailedModal: false,
        requestquotation: false,
      },

      selects: {
        servicelocation: "",
        servicelocations: [],
        deliveryoption: "",
        deliveryoptions: [
          {
            value: 1,
            label: 'Delivery'
          },
          {
            value: 2,
            label: 'Self-pickup'
          },
        ],
        country: "",
        countries: [
          {
            value: 1,
            label: "Malaysia",
          },
        ],
        state: "",
        states: [
          {
            value: 1,
            label: "Johor",
          },
          {
            value: 2,
            label: "Kedah",
          },
          {
            value: 3,
            label: "Kelantan",
          },
          {
            value: 4,
            label: "Melaka",
          },
          {
            value: 5,
            label: "Negeri Sembilan",
          },
          {
            value: 6,
            label: "Pahang",
          },
          {
            value: 7,
            label: "Perak",
          },
          {
            value: 8,
            label: "Perlis",
          },
          {
            value: 9,
            label: "Pulau Pinang",
          },
          {
            value: 10,
            label: "Sarawak",
          },
          {
            value: 11,
            label: "Selangor",
          },
          {
            value: 12,
            label: "Terengganu",
          },
          {
            value: 13,
            label: "Kuala Lumpur",
          },
          {
            value: 14,
            label: "Labuan",
          },
          {
            value: 15,
            label: "Sabah",
          },
          {
            value: 16,
            label: "Putrajaya",
          },
        ]
      },

    };
  },
  computed: {
    allproducts() {
      return this.products.length > 0 && this.cartids.length === this.products.length;
    },

    canrequest() {
      return this.cartids.length === 0;
    },

    candeliver() {
      return (this.addressline1 === '' || this.city === '' || this.postcode.length !== 5 || this.selects.state.label === '');
    },

    cansubmit() {
      return this.selects.servicelocation === '';
    },

    selectedItemsCount() {
      return this.products.filter(product => product.selected).length;
    }
  },
  methods: {
    validatePostcode() {
      if (this.postcode.length > 5) {
        this.postcode = this.postcode.slice(0, 5);
      }
    },
    getDeliveryOption() {
      this.selects.deliveryoptions = [];

      this.$http.get(":10001/api/v1/shop/public/delivery_type").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].id,
            };

            this.selects.deliveryoptions.push(obj);
          }
        }
      });
    },
    selectAll(event) {
      if (event.target.checked) {
        this.cartids = this.products.map(product => product.cartid);
      } else {
        this.cartids = [];
      }
    },

    updateCartIds(option, event) {
      if (event.target.checked) {
        // this.cartids.push(option);
        if (!this.cartids.includes(option)) {
          this.cartids.push(option);
        }
      } else {
        this.cartids = this.cartids.filter(item => item !== option);
      }
      console.log(this.cartids);
    },

    onQuantityChange(product) {
      if (product.quantity < 1) {
        product.quantity = 1;
      }

      let obj = {
        waste_type_id: product.wastetypeid,
        quantity: product.quantity,
        action: '',
      };
      console.log(obj);
      this.$http
        .post(
          ":10001/api/v1/shop/carts", obj
        )
        .then((res) => {
          if (!res.error) {
            this.getCartData();
          } else {
            console.log("not adding");
          }
        }).catch((err) => {
          console.log("not update");
        });
    },

    getServiceLocation() {
      this.selects.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].ServiceLocationId,
              label: response[i].Location,
            };

            this.selects.servicelocations.push(obj);
          }
          console.log(this.selects.servicelocations);
        }
      });
    },
    getData() {
      this.load = true;
      this.products = [];

      this.$http
        .get(":10001/api/v1/shop/carts")
        .then((res) => {
          if (!res.error) {
            let response = res.message.items;

            for (let i = 0; i < response.length; i++) {
              let image = {};
              if (response[i].waste_type != null) {
                if (response[i].waste_type.image != null) {
                  image = {
                    // filename: response[i].waste_type.image.meta.filename,
                    // fileurl: response[i].waste_type.image.url,
                    fileurl: response[i].waste_type.image.url == null ? 'https://afes-eprf.s3.ap-southeast-1.amazonaws.com/default/No_Image_Available.jpg' : response[i].waste_type.image.url,
                    fileid: response[i].waste_type.image.image_id,
                  }
                } else {
                  image = {
                    filename: 'No image found',
                    fileurl: 'https://afes-eprf.s3.ap-southeast-1.amazonaws.com/default/No_Image_Available.jpg',
                    fileid: 0,
                  }
                }
              }
              let obj = {
                cartid: response[i].cart_id,
                quantity: response[i].quantity,
                name: response[i].waste_type.name,
                description: response[i].waste_type.description,
                corrosive: response[i].waste_type.corrosive,
                hazardous: response[i].waste_type.hazardous,
                image: image,
                inventory: response[i].waste_type.inventory.quantity,
                wastetypeid: response[i].waste_type.waste_type_id,
              };
              this.products.push(obj);
            }

            console.log('ni url', this.products[0].image.fileurl);

            this.load = false;
          }
        });
    },
    decreaseQuantity(product) {
      if (product.quantity > 1) {
        product.quantity--;

        let obj = {
          waste_type_id: product.wastetypeid,
          quantity: product.quantity,
          action: '',
        };
        console.log(obj);
        this.$http
          .post(
            ":10001/api/v1/shop/carts", obj
          )
          .then((res) => {
            if (!res.error) {
              this.getCartData();
            } else {
              console.log("not reducing");
            }
          }).catch((err) => {
            console.log("not update");
          });
      } else {
        this.deleteItem(product.cartid);
      }
    },
    increaseQuantity(product) {
      product.quantity++;

      let obj = {
        waste_type_id: product.wastetypeid,
        quantity: product.quantity,
        action: '',
      };
      console.log(obj);
      this.$http
        .post(
          ":10001/api/v1/shop/carts", obj
        )
        .then((res) => {
          if (!res.error) {
            this.getCartData();
          } else {
            console.log("not adding");
          }
        }).catch((err) => {
          console.log("not update");
        });
    },
    deleteProduct(id) {
      if (this.cartids.length > 0) {
        swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-primary btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "Continue",
          buttonsStyling: false,
        }).then((result) => {
          console.log(result);
          if (result.value == true) {
            if (this.cartids.length == 0) {
              this.$http
                .delete(
                  ":10001/api/v1/shop/carts/" +
                  id
                )
                .then((res) => {
                  if (!res.error) {
                    let response = res.message;
                    console.log(response);
                    this.message = response;
                    this.modals.removeModal = true;

                    this.getData();
                  } else {
                    let response = res.message;
                    this.message = response;
                    this.modals.removeFailedModal = true;
                  }
                });
            } else if (this.cartids.length >= 1) {
              console.log('sini kan');
              const deletePromises = [];

              for (let i = 0; i < this.cartids.length; i++) {
                const deletePromise = this.$http
                  .delete(
                    ":10001/api/v1/shop/carts/" +
                    this.cartids[i]
                  )
                  .then((res) => {
                    if (!res.error) {
                      let response = res.message;

                      console.log(response);
                      this.message = response;

                      console.log(this.cartids);


                      if (this.cartids.length > 0) {
                        this.cartids = [];
                        // this.cartids = this.cartids.filter(item => item !== id)
                      }
                      console.log(this.cartids);

                      this.modals.removeModal = true;



                    } else {
                      let response = res.message;
                      this.message = response;
                      this.modals.removeFailedModal = true;
                    }
                  }).catch((error) => {
                    console.error("Upload failed:", error);
                  });

                deletePromises.push(deletePromise);
              }

              Promise.all(deletePromises).then(() => {
                setTimeout(() => {
                  this.getData();
                }, 1000);
                this.modals.removeModal = true;
              }).catch((error) => {
                console.error("One or more uploads failed:", error);
              }).finally(() => {
              });
            }
          }
        });
      } else {
        swal({
          title: `Info!`,
          text: "Please select products to delete",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },

    deleteItem(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log('yang ni kan')
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/carts/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;

                if (this.cartids.length > 0) {
                  this.cartids = this.cartids.filter(item => item !== id)
                }
                console.log(this.cartids);

                this.modals.removeModal = true;


                setTimeout(() => {
                  this.getData();
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    requestQuotation() {
      let address = {};
      if (this.selects.deliveryoption == 2)
        address = {
          line_1: this.addressline1, //required
          line_2: this.addressline2, //optional
          postcode: this.postcode.toString(), //required
          city: this.city, //required
          state: this.selects.state.label, //required
          country: this.selects.country.label //optional
        };
      else if (this.selects.deliveryoption == 1) {
        address = null
      }

      let obj = {
        cart_id: this.cartids,
        customer_remark: this.custremark,
        service_location_id: this.selects.servicelocation,
        delivery_type: this.selects.deliveryoption,
        address: address,
      };
      console.log(obj);
      this.$http
        .post(
          ":10001/api/v1/shop/quote", obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: 'Request quotation success.',
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.requestquotation = false;
                this.goBack();
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        }).catch((err) => {
          swal({
            title: `Error!`,
            text: 'Request quotation failed.',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },
    buyNow() {
      let obj = {
        waste_type_id: 34,
        quantity: 2,
        customer_remark: this.custremark,
        service_location_id: this.selects.servicelocation,
      };

      this.$http
        .post(
          ":10001/api/v1/shop/quote/buy_now", obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: 'Request quotation success.',
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.requestquotation = false;
                this.goBack();
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        }).catch((err) => {
          swal({
            title: `Error!`,
            text: 'Request quotation failed.',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    goBack() {
      this.$router.push('/Vessel/BrowseProduct');
    }
  },
  created() {
    this.getData();
    this.getServiceLocation();
    this.getDeliveryOption();
  },
  mounted() {
    this.selects.country = this.selects.countries[0];
  }
};
</script>


<style scoped>
.container {
  padding: 20px;
}

.cart-table {
  margin-top: 20px;
}

.select-all-header {
  /* display: flex; */
  align-items: center;
  /* justify-content: space-between; */
  color: #358CCB !important;
  margin-bottom: 10px;
  border-radius: 5px;
  background: white;
  padding: 10px 0px 10px 0px;
}

.select-all-header input[type="checkbox"] {
  margin-right: 10px;
}

.select-all-text,
.header-text {
  font-size: 15px;
  color: #358CCB;
}

.header-text {
  font-size: 15px;
  font-weight: bold;
  color: black;
}

.product-list {
  display: flex;
  flex-direction: column;
}

.product-row {
  display: flex;
  align-items: center;
  background-color: white;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: none !important;
  width: 100%;
}

.product-image {
  width: 150px;
  height: 150px;
  margin-left: 40px;
  margin-right: 40px;
}

.product-details {
  box-shadow: none !important;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding-left: 120px;
  padding-right: 40px;
}

.product-name {
  text-align: center;
  font-size: 15px;
  color: #707070;
}

.quantity-control {
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: 30px;
  overflow: hidden;
  border: 1px solid #C5C5C5;
  width: 120px;
}

.quantity-control button {
  border: none;
  background-color: transparent;
  color: black;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 20px;
}

.quantity-display {
  border: none;
  border: 1px solid #C5C5C5;
  text-align: center;
  width: 40%;
  font-size: 16px;
  color: #007bff;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 25px;
  line-height: 30px;
}

.btn-danger {
  box-shadow: none !important;
  border: none;
  color: white;
  background: red;
  border-radius: 0px 5px 5px 0px;
  padding: 20px;
  margin: 0px;
  height: 200px;
  margin-left: 180px;
}

.btn-danger:hover {
  background: red;
  cursor: pointer;
}

.cart-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}

.tim-icons {
  color: #e60000;
}

.cart-footer p {
  margin: 0;
  color: #707070;
  margin-right: 20px;
}

.btn-primary {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
}

.btn-back {
  color: #358CCB;
  background: transparent;
}

.btn-back:hover {
  color: #358CCB !important;
  text-decoration: underline;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.no-stepper::-webkit-outer-spin-button,
.no-stepper::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-stepper[type=number] {
  -moz-appearance: textfield;
}

.btn-decrease {
  background-color: white;
  border: none;
  height: 25px;
  width: 30px;
  border-top: 1px solid #C5C5C5;
  border-bottom: 1px solid #C5C5C5;
  border-left: 1px solid #C5C5C5;
  border-radius: 21px 0px 0px 21px;
}

.btn-increase {
  background-color: white;
  border: none;
  height: 25px;
  width: 30px;
  border-top: 1px solid #C5C5C5;
  border-bottom: 1px solid #C5C5C5;
  border-right: 1px solid #C5C5C5;
  border-radius: 0px 21px 21px 0px;
}
</style>
